var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercardColored = function SvgMastercardColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 840 600"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#666",
    mask: "url(#mastercard_colored_svg__mask-2)",
    strokeWidth: 10,
    fill: "#FFF",
    xlinkHref: "#mastercard_colored_svg__path-1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 120)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F99600",
    cx: 296,
    cy: 140,
    rx: 139,
    ry: 140
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EC000A",
    cx: 139,
    cy: 140,
    rx: 139,
    ry: 140
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 24.34c-36.824 25.292-61 67.883-61 116.16s24.176 90.868 61 116.16c36.824-25.292 61-67.883 61-116.16s-24.176-90.868-61-116.16Z",
    fill: "#FF5300"
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: ".SFNSText-Regular, .SF NS Text",
    fontSize: 79.663,
    fill: "#404347",
    transform: "translate(189 120)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.871,
    y: 340
  }, "mastercard")))));
};
export default SvgMastercardColored;